
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  dict: state => state.app.dict,
  studentLess: state => state.app.studentLess,
  classes: state => state.app.classes,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js